import React from 'react';
import cn from 'classnames';
import "./AspectRatio.css";
var styles = { "aspectRatio": "e9212e", "aspectRatio_1-1": "a93d1c", "aspectRatio_2-3": "e65a33", "aspectRatio_3-1": "acd2ae", "aspectRatio_4-5": "e7d983", "aspectRatio_16-9": "ed9ecc" };
const AspectRatio = ({ ratio = '2:3', className, children, testId, }) => {
    const [width, height] = ratio.split(':').map(Number);
    return (React.createElement("div", { className: cn(className, styles.aspectRatio, styles[`aspectRatio_${width}-${height}`]), "data-testid": testId }, children));
};
export default AspectRatio;
//# sourceMappingURL=AspectRatio.js.map